import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import be from "../../BE";
import auth from "../../Account/Auth";

function User({ setStage }) {
  const { t } = useTranslation(["onboarding"]);
  const history = useHistory();
  const userFullName = auth.getProperty({
    storageKey: "userSession",
    path: ["profileObj", "name"],
    fallback: "",
  });
  const [fullName, setFullName] = useState(userFullName);
  const [industry, setIndustry] = useState("not-set");
  const [teamSize, setTeamSize] = useState("");

  const saveUser = async (e) => {
    e.preventDefault();
    const body = {
      fullName: fullName,
      industry: industry,
      teamSize: teamSize,
    };

    try {
      await auth
        .isAuthenticated()
        .then(() => {
          be.post("Onboarding", "/onboarding/fullname", body, true, true)
            .then((response) => {
              auth.refresh();
              console.log("[onboarding][user] user saved");
            })
            .catch((error) => {
              console.error(
                "[onboarding][user] network error while saving user:",
                error
              );
            });
        })
        .catch((error) => {
          console.error(
            "[onboarding][user] authentication error while saving user:",
            error
          );
          history.push({ pathname: "/login" });
        });
    } catch (error) {
      console.error(
        "[onboarding][user] functional error while saving user:",
        error
      );
    } finally {
      setStage("event-name");
    }
  };

  return (
    <form onSubmit={saveUser}>
      <h1 className="tw-mb-4 tw-text-2xl tw-font-extrabold tw-leading-tight tw-tracking-tight tw-text-gray-900 sm:tw-mb-6 tw-dark:text-white">
        {t("user.title")}
      </h1>

      <p className="tw-mb-4 tw-text-lg tw-font-light tw-text-gray-500 tw-dark:text-gray-400">
        {t("user.fullName")}
      </p>

      <input
        type="text"
        name="full-name"
        id="full-name"
        className="tw-bg-gray-50 !tw-border-2 tw-border-gray-200 tw-text-gray-900 tw-rounded-lg focus:!tw-ring-primary-600 focus:!tw-border-primary-600 tw-w-full tw-p-5 tw-text-gray-500 hover:tw-text-gray-600 hover:tw-bg-gray-100 tw-dark:bg-gray-800 tw-dark:border-gray-700 tw-dark:placeholder-gray-400 tw-dark:text-white tw-dark:hover:bg-gray-700"
        placeholder="John Smith"
        value={fullName}
        onChange={(e) => setFullName(e.target.value)}
        required
      />

      <p className="tw-my-4 tw-text-lg tw-font-light tw-text-gray-500 tw-dark:text-gray-400">
        {t("user.role")}
      </p>

      <div className="tw-relative">
        <select
          name="profession"
          value={industry}
          onChange={(e) => setIndustry(e.target.value)}
          className="tw-block tw-w-full tw-p-5 tw-text-gray-500 tw-border-2 tw-border-gray-200 tw-rounded-lg tw-bg-gray-50 hover:tw-text-gray-600 hover:tw-bg-gray-100 tw-dark:text-gray-400 tw-dark:border-gray-700 tw-dark:bg-gray-800 tw-dark:hover:bg-gray-700 appearance-none"
        >
          <option value="not-set">...</option>
          <option value="designer">{t("user.roles.designer")}</option>
          <option value="developer">{t("user.roles.developer")}</option>
          <option value="sales">{t("user.roles.sales")}</option>
          <option value="marketing">{t("user.roles.marketing")}</option>
          <option value="customer-care">{t("user.roles.customerCare")}</option>
          <option value="recruiting">{t("user.roles.recruiting")}</option>
          <option value="other">{t("user.roles.other")}</option>
        </select>
      </div>

      <p className="tw-my-4 tw-text-lg tw-font-light tw-text-gray-500 tw-dark:text-gray-400">
        {t("user.howMany")}
      </p>

      <ul className="tw-mb-6 tw-gap-6 tw-inline-flex">
        <li>
          <input
            type="radio"
            id="just-me"
            name="team-size"
            value="just-me"
            className="!tw-hidden tw-peer"
          />
          <label
            onClick={() => setTeamSize("just-me")}
            htmlFor="just-me"
            className="tw-inline-flex tw-items-center tw-justify-center tw-w-auto tw-p-5 tw-text-gray-500 tw-border-2 tw-border-gray-200 tw-rounded-lg tw-cursor-pointer tw-dark:hover:text-gray-300 tw-dark:border-gray-700 tw-dark:peer-checked:text-primary-500 peer-checked:tw-border-primary-600 peer-checked:tw-text-primary-600 tw-bg-gray-50 hover:tw-text-gray-600 hover:tw-bg-gray-100 tw-dark:text-gray-400 tw-dark:bg-gray-800 tw-dark:hover:bg-gray-700"
          >
            <span className="tw-w-full">{t("user.justMe")}</span>
          </label>
        </li>
        <li>
          <input
            type="radio"
            id="2-10"
            name="team-size"
            value="2-10"
            className="!tw-hidden tw-peer"
          />
          <label
            onClick={() => setTeamSize("2-10")}
            htmlFor="2-10"
            className="tw-inline-flex tw-items-center tw-justify-center tw-w-auto tw-p-5 tw-text-gray-500 tw-border-2 tw-border-gray-200 tw-rounded-lg tw-cursor-pointer tw-dark:hover:text-gray-300 tw-dark:border-gray-700 tw-dark:peer-checked:text-primary-500 peer-checked:tw-border-primary-600 peer-checked:tw-text-primary-600 tw-bg-gray-50 hover:tw-text-gray-600 hover:tw-bg-gray-100 tw-dark:text-gray-400 tw-dark:bg-gray-800 tw-dark:hover:bg-gray-700"
          >
            <span className="tw-w-full">2-10</span>
          </label>
        </li>
        <li>
          <input
            type="radio"
            id="11-50"
            name="team-size"
            value="11-50"
            className="!tw-hidden tw-peer"
          />
          <label
            onClick={() => setTeamSize("11-50")}
            htmlFor="11-50"
            className="tw-inline-flex tw-items-center tw-justify-center tw-w-auto tw-p-5 tw-text-gray-500 tw-border-2 tw-border-gray-200 tw-rounded-lg tw-cursor-pointer tw-dark:hover:text-gray-300 tw-dark:border-gray-700 tw-dark:peer-checked:text-primary-500 peer-checked:tw-border-primary-600 peer-checked:tw-text-primary-600 tw-bg-gray-50 hover:tw-text-gray-600 hover:tw-bg-gray-100 tw-dark:text-gray-400 tw-dark:bg-gray-800 tw-dark:hover:bg-gray-700"
          >
            <span className="tw-w-full">11-50</span>
          </label>
        </li>
        <li>
          <input
            type="radio"
            id="50+r"
            name="team-size"
            value="50+"
            className="!tw-hidden tw-peer"
          />
          <label
            onClick={() => setTeamSize("50+")}
            htmlFor="50+"
            className="tw-inline-flex tw-items-center tw-justify-center tw-w-auto tw-p-5 tw-text-gray-500 tw-border-2 tw-border-gray-200 tw-rounded-lg tw-cursor-pointer tw-dark:hover:text-gray-300 tw-dark:border-gray-700 tw-dark:peer-checked:text-primary-500 peer-checked:tw-border-primary-600 peer-checked:tw-text-primary-600 tw-bg-gray-50 hover:tw-text-gray-600 hover:tw-bg-gray-100 tw-dark:text-gray-400 tw-dark:bg-gray-800 tw-dark:hover:bg-gray-700"
          >
            <span className="tw-w-full">50+</span>
          </label>
        </li>
      </ul>

      <button
        type="submit"
        className="tw-w-full tw-px-5 tw-py-2.5 sm:tw-py-3.5 tw-text-sm tw-font-medium tw-text-center tw-text-white tw-rounded-lg tw-bg-primary-600 hover:tw-bg-primary-700 focus:tw-ring-4 focus:tw-outline-none focus:tw-ring-primary-300 tw-dark:bg-primary-600 tw-dark:hover:bg-primary-700 tw-dark:focus:tw-ring-primary-800"
      >
        {t("user.nextBtn")}
      </button>
    </form>
  );
}

export default User;
